import { useConsultDoctorContext } from "../../Contexts/ConsultDoctorContext";
import { baseUrl } from "../../utilities/configurations";
import CloseIcon from "@mui/icons-material/Close";
import { CircularProgress } from "@mui/material";
import apiRequest from "../../utilities/request";
import React, { useState } from "react";
import toast from "react-hot-toast";
import PropTypes from "prop-types";

function DeleteButton({ id }) {
  const { selectedPolicy, getPreferredDoctors } = useConsultDoctorContext();
  const [loadState, setLoadState] = useState("");

  const handleDeleteDoctor = async () => {
    setLoadState("delete");
    const res = await apiRequest(
      baseUrl + `/consult/delete-preferred-doctor`,
      "POST",
      {
        cardNo: selectedPolicy.cardNo,
        physicianId: id,
      }
    );
    if (!res.error) {
      getPreferredDoctors("");
      toast.success("Doctor successfully deleted.");
      setLoadState("delete success");
    } else {
      console.log(res.message);
      setLoadState("delete failed");
    }
  };

  return (
    <button
      style={{ height: "auto" }}
      className="p-3 w-16 text-[#000]"
      disabled={loadState === "delete"}
      onClick={handleDeleteDoctor}
    >
      {["delete", "delete success"].includes(loadState) ? (
        <CircularProgress size={20} color="inherit" />
      ) : (
        <CloseIcon sx={{ fontSize: 20 }} />
      )}
    </button>
  );
}

DeleteButton.propTypes = {
  id: PropTypes.string,
};

function PreferredDoctor({ doctors }) {
  const { handleProceedWithPreferredDoc } = useConsultDoctorContext();

  return doctors.map((item) => (
    <div
      className="flex border rounded-lg mb-2 overflow-hidden"
      key={`${item.physicianId}_${item.specializationId}`}
    >
      <button
        className="flex flex-col flex-1 text-left p-3"
        onClick={() => handleProceedWithPreferredDoc(item)}
      >
        <span className="text-sm">{item.physician}</span>
        <small>{item.location}</small>
      </button>
      <DeleteButton id={item.physicianId} />
    </div>
  ));
}

PreferredDoctor.propTypes = {
  doctors: PropTypes.array,
};

export default PreferredDoctor;
